import "./index.scss";
import "antd/dist/antd.css";
import React, { useEffect, useState } from "react";
import {
  Input,
  Space,
  Button,
  Row,
  Col,
  Table,
  Tabs,
  Tag,
  Tooltip,
  Form,
  notification,
  AutoComplete,
  Select,
  Modal,
  Dropdown,
  Menu,
  List,
  Card,
  Checkbox,
} from "antd";
import { FaSearch } from "react-icons/fa";
import API_SERVICE from "shared/services/api-service";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import debounce from "lodash/debounce";
import { getMaskedMobile, getUser, hasUserRole } from "shared/services/Utility";
import type { ColumnsType } from "antd/es/table";
import { ReactComponent as IconShare } from "../../../assets/images/shareIcon.svg";
import { ReactComponent as IconCall } from "../../../assets/images/call.svg";
import { ReactComponent as IconTriangle } from "../../../assets/images/triangle.svg";
import { ReactComponent as IconPlayNewBorder } from "../../../assets/images/play_new_border.svg";
import { ReactComponent as IconEditBorder } from "../../../assets/images/edit_border.svg";
import {ReactComponent as IconCustomer360} from "../../../assets/images/Customer360.svg";
import whatsappIcon from "../../../assets/images/whatsappIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import {
  setActiveKey,
  setIsShowFilter,
  setLeadPageNo,
  setLeadPageSize,
  setLeadSearchParam,
  setPostLenderCase,
  setPreLenderCase,
  setDisbursementCase,
  setRestFilterData,
} from "shared/redux/lead-reducer";
import LeadFilterConnector from "./LeadFilter/LeadFilterConnector";
import blackFilterIcon from "../../../assets/images/blackFilter.svg";
import blackRefereshIcon from "../../../assets/images/blackReferesh.svg";
import bullHorn from "../../../assets/images/bullhorn.svg"
import { setScreenHeader } from "shared/redux/common-reducer";
import { DownOutlined } from "@ant-design/icons";
import AppLoading from "../AppLoading/AppLoading";
import Customer360 from "../LeadNew/LeadDetail/Customer360";
import {
  setBulkLoginStartPageNo,
  setBulkLoginStartPageSize,
} from "shared/redux/bulkLoginStart-reducer";
import OIButton from "shared/ComponentsOI/OIButton/OIButton";

const { CheckableTag } = Tag;
const { TabPane } = Tabs;

type Props = {};

const LeadPage: React.FunctionComponent<Props> = () => {
  const userRolePermission = hasUserRole();
  const history = useHistory();
  const location = useLocation() as any;
  const [allLeadsData, setAllLeadsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [counts, setCounts] = useState({
    totalCases: 0,
    totalCasesInLeadState: 0,
    totalCasesInProspectState: 0,
    totalCasesInVisitState: 0,
    totalCasesInDocumentState: 0,
    totalLenderAssignedCases: 0,
    totalLenderLoggedInCases: 0,
    totalLenderSanctionedCases: 0,
    totalLenderRejectedCases: 0,
    totalLenderWithdrawnCases: 0,
    totalLenderPendencyCases: 0,
    totalLenderDisbursedCases: 0,
    totalInsurerPolicyIssued: 0,
    totalInsurerPolicyCounterOffer:0,
    totalInsurerPolicyUnderwritingReject:0,
  });
  const [addButtonDisabled, setAddButtonDisabled] = useState(false);
  const [prospectOnboardingStatus, setProspectOnboardingStatus] = useState([]);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const lead: any = useSelector((state: RootState) => state.lead);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [assignToData, setAssignToData] = useState([] as any);
  const [selectedAssignTo, setSelectedAssignTo] = useState(null as any);
  const [errorDisplay, setErrorDisplay] = useState(false);
  const [errorCaseIds, setErrorCaseIds] = useState([] as any);
  const [selectedCaseIds, setSelectedCaseIds] = useState([] as any);
  const [isModalWhatsappVisible, setIsModalWhatsappVisible] = useState(false);
  const [selectedLead, setSelectedLead] = useState<any>(null);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isWhatsappEnable, setIsWhatsappEnable] = useState(false);
  const [isOneView, setIsOneView] = useState(false)
  const { tenantInfo }: any = useSelector((state: RootState) => state.tenant);
  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null as any);
  const [customerCaseId, setCustomerCaseId] = useState("")
  const { appColors, isMobile }: any = useSelector(
    (state: RootState) => state.common
  );
  const isTenantWorkingCapitalEnabled = localStorage.getItem("tenantWorkingCapitalEnabled") == 'true' ? true : false;
  const dialerCampaignEnabled = ["T3", "NEODOVE"].includes(tenantInfo?.dialerConfiguration?.dialerProvider)
  const isCustomer360Enabled = localStorage.getItem("customer360Enabled") == 'true' 
  
  const leadNameBullHorn = (_: any, record: any) => {
    const showBullHornIcon = (record?.dsaCaseAdditionalFileds?.diallerCampaignIds?.length ?? record?.diallerCampaignIds?.length) > 0;
    return (
      <div>
        {showBullHornIcon ?
          (
            <Tooltip color={"#1A3175"} title="Indicates whether case has been sent to dialler campaign">
              <img
                src={bullHorn}
                alt=""
                height={24}
              />
            </Tooltip>
          ) : ""}
      </div >
    );
  }

  const preLenderColumns: ColumnsType<any> = [
    {
      title:
        <>
          <Tooltip color={"#1A3175"} title="Indicates whether case has been sent to dialler campaign">
            <img
              src={bullHorn}
              alt=""
              height={24}
            />
          </Tooltip>
        </>,
      dataIndex: ["contactDetails", "firstName"],
      key: "name",
      ellipsis: true,
      render: leadNameBullHorn,
    },
    {
      title:"Lead",
      dataIndex: ["contactDetails", "firstName"],
      key: "name",
      width: 50,
      ellipsis: true,
      render: (_: any, record: any) => {
        const leadNames = record?.contactDetails?.firstName;
        if (lead?.activeKey == "PRE_LENDER" && (leadNames?.length ?? 0) > 0) {
          if ((leadNames?.length ?? 0) > 0) {
            return (
              <div style={{ width: "200px", whiteSpace: "pre-line" }}>
                <text>{leadNames}</text>
              </div>
            );
          }
        }
        return "";
      },
    },
    {
      title: "Product Type",
      dataIndex: ["loanType"],
      key: "productType",
      ellipsis: true,
    },
    {
      title: "Lender Name",
      dataIndex: ["lenderProposalDTO", "allLenderNames"],
      key: "allLenderNames",
      ellipsis: true,
      render: (_: any, record: any) => {
        const lenderNames = record?.lenderProposalDTO?.allLenderNames;
        if (lead?.activeKey == "PRE_LENDER" && (lenderNames?.length ?? 0) > 0) {
          if ((lenderNames?.length ?? 0) > 0) {
            return (
              <div style={{ width: "200px", whiteSpace: "pre-wrap" }}>
                <text>{lenderNames}</text>
              </div>
            );
          }
        }
        return "NA";
      },
    },
    {
      title: "Lender Current Stage",
      dataIndex: ["lenderProposalDTO", "allLenderStages"],
      key: "allLenderStages",
      ellipsis: true,
      render: (_: any, record: any) => {
        let lenderStage = record?.lenderProposalDTO?.allLenderStages;
        return (
          <div style={{ width: "200px", whiteSpace: "pre-wrap" }}>
            <text>{lenderStage ?? ""}</text>
          </div>
        );
      },
    },
    {
      title: "Drop Off Stage",
      dataIndex: "currDropOffStage",
      key: "currDropOffStage",
      width: 50,
      ellipsis: true,
      render: (_: any, record: any) => {
        let value = {} as any;
        value = prospectOnboardingStatus?.find((item: any) => {
          return item?.key === record?.currDropOffStage;
        });
        return value?.value;
      },
    },    
    {
      title: "Case Stage",
      dataIndex: "caseStatus",
      key: "stage",
    },
    {
      title:"Pre-Qualified offer",
      dataIndex:"allPreQualifiedLenderNames",
      key:"allPreQualifiedLenderNames",
      render: (_: any, record: any) =>
        record?.allPreQualifiedLenderNames && record?.allPreQualifiedLenderAmounts ?
        record?.allPreQualifiedLenderNames  + ", " + Math.trunc(record?.allPreQualifiedLenderAmounts) :
        record?.allPreQualifiedLenderNames ? record?.allPreQualifiedLenderNames :
        record?.allPreQualifiedLenderAmounts ? record?.allPreQualifiedLenderAmounts : ""
    },
    {
      title:"Pre-Qualified Expiry Date",
      dataIndex:"allPreQualifiedExpiryDates",
      key:"allPreQualifiedExpiryDates",
      render: (_: any, record: any) =>
      record?.allPreQualifiedExpiryDates &&
        moment(record?.allPreQualifiedExpiryDates)
          .locale("en")
          .format("MMM DD YYYY"),
    },
    {
      title: "Lead Originator",
      dataIndex: ["leadOriginatorDetails", "companyName"],
      key: "leadOriginator",
    },
    {
      title: "Mobile Number",
      dataIndex: ["contactDetails", "mobileNumber"],
      key: "mobileNumber",
      render: (_: any, record: any) =>
        record?.contactDetails?.mobileNumber.startsWith("1")
          ? ""
          : getMaskedMobile(userRolePermission["MaskMobileNumber"], record?.contactDetails?.mobileNumber),
    },
    {
      title: "Case Created Date",
      dataIndex: "caseCreatedDate",
      key: "caseCreatedDate",
      width: 180,
      render: (_: any, record: any) =>
        moment(record?.caseCreatedDate)
          .locale("en")
          .format("MMM, DD, YYYY HH:mm"),
    },
    {
      title: "Days Open",
      dataIndex: "daysOpen",
      key: "daysOpen",
      width: 30,
    },
    {
      title: "Assign to Sales User",
      dataIndex: "assignedToSalesUserName",
      key: "assignedSalesUserName",
      width: 30,
    },
    {
      title: "Version",
      width: 50,
      dataIndex: "productVersion",
      key: "version",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      align: "center",
      width: 60,
      render: (_: any, record: any) => {
        const isAction =
          ("LEAD" === lead?.preLenderCase && "PRE_LENDER" === lead?.activeKey) ||
          ("PRE_LENDER" === lead?.activeKey &&
            "ALL" === lead?.preLenderCase &&
            record?.caseStatus === "Lead");
        let isLoanProduct = (record?.loanProductId?.length ?? 0) == 0;
        return (
          <Space className="action-button" size="small">
            <Button
              className="custome-btn-icon-secondary"
              style={{ "--bgColor": appColors?.appSecondaryColor ?? "" } as any}
              size="small"
              // type="primary"
              // shape="circle"
              hidden={
                "LEAD" === lead.preLenderCase && "PRE_LENDER" === lead.activeKey
              }
              onClick={() => getShareLinkId(record)}
              icon={<IconShare />}
            />

            { record.errorMessages !== null && (
              <Tooltip title={`${record.errorMessages}`}>
                <span>{<IconTriangle />}</span>
                </Tooltip>
            )}
            {isWhatsappEnable && (
              <Button
                size="small"
                hidden={!record?.isWhatsAppEnabled}
                onClick={() => {
                  setSelectedLead(record);
                  handleClick(record?.caseId);
                }}
                icon={
                  <img
                    src={whatsappIcon}
                    alt=""
                    height={24}
                    style={{ marginTop: "-4px" }}
                  />
                }
              />
            )}

            {isAction || isLoanProduct ? (
              <div style={{ width: "24px" }}></div>
            ) : (
              <Button
                className="custome-btn-icon-play"
                style={{ "--bgColor": appColors?.appPrimaryColor ?? "" } as any}
                size="small"
                type="text"
                onClick={() => goToLeadDetails(record)}
                icon={<IconPlayNewBorder />}
              />
            )}
            <Button
              className="custome-btn-icon-secondary"
              style={{ "--bgColor": appColors?.appSecondaryColor ?? "" } as any}
              size="small"
              type="text"
              disabled={userRolePermission["ReadOnly"]}
              hidden={
                !(
                  userRolePermission["UpdateLead"] ||
                  userRolePermission["Admin"]
                )
              }
              onClick={() => goToLeadEdit(record)}
              icon={<IconEditBorder />}
            />
            <Button
              className="custome-btn-icon-play"
              style={{ "--bgColor": appColors?.appPrimaryColor ?? "" } as any}
              size="small"
              type="text"
              onClick={() => goToOneView(record)}
              icon={<IconCustomer360 />}
            />
            {/* <Button
            className="pink"
            size="small"
            type="primary"
            shape="circle"
            icon={<AiFillDelete />}
          /> */}
          </Space>
        );
      },
    },
  ]

  const preLenderCases =
    tenantInfo?.businessProductType === "INSURANCE"
      ? [
          {
            key: "ALL",
            value: "All",
          },
          {
            key: "LEAD",
            value: "Lead",
          },
          {
            key: "PROSPECT",
            value: "Prospect",
          },
          {
            key: "DOCUMENTATION",
            value: "Documentation",
          },
        ]
      : [
          {
            key: "ALL",
            value: "All",
          },
          {
            key: "LEAD",
            value: "Lead",
          },
          {
            key: "PROSPECT",
            value: "Prospect",
          },
          {
            key: "VISIT",
            value: "Visit",
          },
          {
            key: "DOCUMENTATION",
            value: "Documentation",
          },
        ];

  const postLenderCases =
    tenantInfo?.businessProductType === "INSURANCE"
      ? [
          {
            key: "LOGGED",
            value: "Log in",
          },
          {
            key: "POLICY_ISSUED",
            value: "Policy Issued",
          },
          {
            key: "WITHDRAWN",
            value: "Withdrawn",
          },
          {
            key:"COUNTER_OFFER",
            value: "Counter Offer",
          },
          {
            key:"UNDERWRITING_REJECT",
            value:"Underwriting Reject",
          },
        ]
      : [
          {
            value: "Lender Selection",
            key: "ASSIGNED",
          },
          {
            value: "Log in",
            key: "LOGGED",
          },
          {
            key: "SANCTIONED",
            value: "Sanctioned",
          },
          {
            key: "REJECTED",
            value: "Rejected",
          },
          {
            key: "WITHDRAWN",
            value: "Withdrawn",
          },
          {
            key: "PENDENCY",
            value: "Pendency",
          },
          {
            key: "DISBURSED",
            value: "Disbursed",
          },
        ];

        const disbursementCases = [
          {
            key: "ALL",
            value: "All"
          },
          {
            key: "COMPLETE",
            value: "Complete",
          },
          {
            key: "INCOMPLETE",
            value: "Incomplete",
          },
        ];

  if (location?.state) {
    /*if (location?.state?.activeTab) {
      dispatch(setActiveKey(location?.state?.activeTab));
    }

    if (location?.state?.name && "POST_LENDER" === location?.state?.activeTab)
      dispatch(setPostLenderCase(location?.state?.name));
    else if (location?.state?.name)
      dispatch(setPreLenderCase(location?.state?.name));*/

    location.state = null;
  }

  /* useEffect functions */
  useEffect(() => {
    dispatch(setScreenHeader({ screenTitle: "Manage Leads" }));

    let enumValues = localStorage.getItem("enumValues") as any;
    if (enumValues) {
      enumValues = JSON.parse(enumValues);
      let filteredProspectOnboardingStatus = enumValues?.find(
        (item: any) => item.propertyName === "PROSPECT_ONBOARDING_STATUS"
      );

      if (filteredProspectOnboardingStatus)
        setProspectOnboardingStatus(
          filteredProspectOnboardingStatus?.keyAndDisplayValueList
        );
    }
  }, []);

  useEffect(() => {
    if (
      userRolePermission["CreatAdmineOperations"] === true ||
      userRolePermission["CreateOperations"] === true ||
      userRolePermission["CreateLead"] === true
    ) {
      setAddButtonDisabled(false);
    } else {
      setAddButtonDisabled(true);
    }
    // dispatch(setLeadPageNo(1));
    form.setFieldsValue({
      searchBox: lead.searchParam,
    });

    getAllLeadsData(
      lead.pageNo,
      lead.pageSize,
      lead.searchParam,
      lead.filterData
    );
  }, [
    lead.activeKey,
    lead.searchParam,
    lead.preLenderCase,
    lead.postLenderCase,
    lead.disbursementCase,
    lead.filterData,
  ]);

  const colLenderName = (_: any, record: any) => {
    const lenderNames = lead.activeKey === "PRE_LENDER" ?
              record?.lenderProposalDTO?.allLenderNames : 
              record?.caseDetails?.allLenderNames;
    if (lead.activeKey == "PRE_LENDER" && (lenderNames?.length ?? 0) > 0) {
      if ((lenderNames?.length ?? 0) > 0) {
        return (
          <div style={{ width: "200px", whiteSpace: "pre-wrap" }}>
            <text>{lenderNames}</text>
          </div>
        );
      }
    } else {
      if (
        record?.caseDetails?.lenderActivityHolder?.lenderActivityDetails.length > 0
      ) {
        return (
          <div style={{ width: "200px", whiteSpace: "pre-wrap" }}>
            <text>
              {
                record?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.at(0)
                  ?.lenderName
              }
            </text>
          </div>
        );
      }
    }
    return "NA";
  };

  const CurrentStage = (_: any, record: any) => {
    let lenderStage = lead.activeKey === "PRE_LENDER" ?
                      record?.lenderProposalDTO?.allLenderStages :
                      record?.caseDetails?.allLenderStages;
    const lenderActivityDetails =
      record?.caseDetails?.lenderActivityHolder?.lenderActivityDetails;
    if (
      (lenderStage?.length ?? 0) === 0 &&
      (lenderActivityDetails?.length ?? 0) > 0
    ) {
      lenderStage =
        record.caseDetails.lenderActivityHolder.lenderActivityDetails[0].status;
    }
    return (
      <div style={{ width: "200px", whiteSpace: "pre-wrap" }}>
        <text>{lenderStage}</text>
      </div>
    );
  };

  const colDropOffStage = (_: any, record: any) => {
    let value = {} as any;
    value = prospectOnboardingStatus?.find((item: any) => {
      return item?.key === record?.currDropOffStage;
    });
    return value?.value;
  };

  const colPreQualifiedOffer = (_: any, record: any) =>{ 
    let preQualifiedLender =  lead.activeKey === "PRE_LENDER" ?
                              record?.allPreQualifiedLenderNames :
                              record?.caseDetails?.allPreQualifiedLenderNames;
    let preQualifiedAmount =  lead.activeKey === "PRE_LENDER" ?
                              record?.allPreQualifiedLenderAmounts :
                              record?.caseDetails?.allPreQualifiedLenderAmounts;
    if (preQualifiedLender && preQualifiedAmount){
      return preQualifiedLender + ", " + Math.trunc(preQualifiedAmount)
    }
    else if (preQualifiedLender){
      return preQualifiedLender
    }
    else {
      return preQualifiedAmount
    }
  }

  const colPreQualifiedExpiryDate = (_: any, record: any) =>  {
    let preQualifiedExpiryDt =  lead.activeKey === "PRE_LENDER" ?
                                record?.allPreQualifiedExpiryDates :
                                record?.caseDetails?.allPreQualifiedExpiryDates;
    if (preQualifiedExpiryDt)
    {
      return (moment(preQualifiedExpiryDt)
      .locale("en")
      .format("MMM DD YYYY"))
    }     
  }
    
  const colMobileNumber = (_: any, record: any) =>
    record?.contactDetails?.mobileNumber.startsWith("1")
      ? ""
      : getMaskedMobile(userRolePermission["MaskMobileNumber"], record?.contactDetails?.mobileNumber);

  const colCaseCreatedDate = (_: any, record: any) =>
    moment(record.caseCreatedDate).locale("en").format("MMM, DD, YYYY HH:mm");

  const colAction = (_: any, record: any) => {
    const isAction =
      ("LEAD" === lead?.preLenderCase && "PRE_LENDER" === lead?.activeKey) ||
      ("PRE_LENDER" === lead?.activeKey &&
        "ALL" === lead?.preLenderCase &&
        record?.caseDetails?.caseStatus === "Lead");
    let isLoanProduct = (record?.loanProductId?.length ?? 0) == 0;
    return (
      <Space className="action-button" size="small">
        {tenantInfo?.businessProductType !== "INSURANCE" &&
          <Button
            className="custome-btn-icon-secondary"
            style={{ "--bgColor": appColors?.appSecondaryColor ?? "" } as any}
            size="small"
            hidden={
              "LEAD" === lead?.preLenderCase && "PRE_LENDER" === lead?.activeKey
            }
            onClick={() => getShareLinkId(record)}
            icon={<IconShare />}
          />
        }

        { record.errorMessages !== null && (
          <Tooltip title={`${record.errorMessages}`}>
            <span>{<IconTriangle />}</span>
            </Tooltip>
        )}

        {isWhatsappEnable && (
          <Button
            size="small"
            hidden={!record?.isWhatsAppEnabled}
            onClick={() => {
              setSelectedLead(record);
              handleClick(record?.caseDetails?.caseId);
            }}
            icon={
              <img
                src={whatsappIcon}
                alt=""
                height={24}
                style={{ marginTop: "-4px" }}
              />
            }
          />
        )}

        {isAction || isLoanProduct ? (
          <div style={{ width: "24px" }}></div>
        ) : (
          <Button
            className="custome-btn-icon-play"
            style={{ "--bgColor": appColors?.appPrimaryColor ?? "" } as any}
            size="small"
            type="text"
            onClick={() => goToLeadDetails(record)}
            icon={<IconPlayNewBorder />}
          />
        )}
        <Button
          className="custome-btn-icon-secondary"
          style={{ "--bgColor": appColors?.appSecondaryColor ?? "" } as any}
          size="small"
          type="text"
          disabled={userRolePermission["ReadOnly"]}
          hidden={
            !(userRolePermission["UpdateLead"] || userRolePermission["Admin"])
          }
          onClick={() => goToLeadEdit(record)}
          icon={<IconEditBorder />}
        />
        <Button
              className="custome-btn-icon-play"
              style={{ "--bgColor": appColors?.appPrimaryColor ?? "" } as any}
              size="small"
              type="text"
              onClick={() => goToOneView(record)}
              icon={<IconCustomer360 />}
            />
      </Space>
    );
  };



  const columns: ColumnsType<any> = [
    {
      title:
        <>
          <Tooltip color={"#1A3175"} title="Indicates whether case has been sent to dialler campaign">
            <img
              src={bullHorn}
              alt=""
              height={24}
            />
          </Tooltip>
        </>,
      dataIndex: ["contactDetails", "firstName"],
      key: "name",
      ellipsis: true,
      render: leadNameBullHorn,
    },
    {
      title:"Lead",
      dataIndex: ["contactDetails", "firstName"],
      key: "name",
      width: 50,
      ellipsis: true,
      render: (_: any, record: any) => {
        const leadNames = record?.contactDetails?.firstName;
          if ((leadNames?.length ?? 0) > 0) {
            return (
              <div style={{ width: "200px", whiteSpace: "pre-line" }}>
                <text>{leadNames}</text>
              </div>
            );
          }
        return "";
      },
    },
    {
      title: "Product Type",
      dataIndex: ["loanType"],
      key: "productType",
      ellipsis: true,
    },
    {
      title: "Lender Name",
      dataIndex: ["caseDetails", "allLenderNames"],
      key: "allLenderNames",
      ellipsis: true,
      render: colLenderName,
    },
    {
      title: "Lender Current Stage",
      dataIndex: ["caseDetails", "allLenderStages"],
      key: "allLenderStages",
      ellipsis: true,
      render: CurrentStage,
    },
    {
      title: "Drop Off Stage",
      dataIndex: "currDropOffStage",
      key: "currDropOffStage",
      width: 50,
      ellipsis: true,
      render: colDropOffStage,
    },
    {
      title: "Case Stage",
      dataIndex: ["caseDetails", "caseStatus"],
      key: "stage",
    },
    {
      title:"Pre-Qualified offer",
      dataIndex:["caseDetails", "allPreQualifiedLenderNames"],
      key:"allPreQualifiedLenderNames",
      render: colPreQualifiedOffer
    },
    {
      title:"Pre-Qualified Expiry Date",
      dataIndex:["caseDetails","allPreQualifiedExpiryDates"],
      key:"allPreQualifiedExpiryDates",
      render: colPreQualifiedExpiryDate      
    },
    {
      title: "Lead Originator",
      dataIndex: ["caseDetails", "connectorDetails", "companyName"],
      key: "sourceOfCase",
    },
    {
      title: "Mobile Number",
      dataIndex: ["contactDetails", "mobileNumber"],
      key: "mobileNumber",
      render: colMobileNumber,
    },
    {
      title: "Case Created Date",
      dataIndex: "caseCreatedDate",
      key: "caseCreatedDate",
      width: 180,
      render: colCaseCreatedDate,
    },
    {
      title: "Days Open",
      dataIndex: "daysOpen",
      key: "daysOpen",
      width: 30,
    },
    {
      title: "Assign to Sales User",
      dataIndex: ["caseDetails", "assignedToUserDetails", "firstName"],
      key: "assignedSalesUserName",
      width: 30,
    },
    {
      title: "Version",
      width: 50,
      dataIndex: "productVersion",
      key: "version",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      align: "center",
      width: 60,
      render: colAction,
    },
  ];

  const columnsInsurence: ColumnsType<any> = [
    {
      title:
        <>
          <Tooltip color={"#1A3175"} title="Indicates whether case has been sent to dialler campaign">
            <img
              src={bullHorn}
              alt=""
              height={24}
            />
          </Tooltip>
        </>,
      dataIndex: ["contactDetails", "firstName"],
      key: "name",
      ellipsis: true,
      render: leadNameBullHorn,
    },
    {
      title:"Lead",
      dataIndex: ["contactDetails", "firstName"],
      key: "name",
      width: 50,
      ellipsis: true,
      render: (_: any, record: any) => {
        const leadNames = record?.contactDetails?.firstName;
          if ((leadNames?.length ?? 0) > 0) {
            return (
              <div style={{ width: "200px", whiteSpace: "pre-line" }}>
                <text>{leadNames}</text>
              </div>
            );
          }
        return "";
      },
    },
    {
      title: "Product Type",
      dataIndex: ["loanType"],
      key: "productType",
      ellipsis: true,
    },
    {
      title: "Insurer",
      dataIndex: [lead.activeKey === "PRE_LENDER"?"lenderProposalDTO":"caseDetails", "allLenderNames"],
      key: "allLenderNames",
      ellipsis: true,
      render: colLenderName,
    },
    {
      title: "Insurer Current Stage",
      dataIndex: ["caseDetails", "allLenderStages"],
      key: "allLenderStages",
      ellipsis: true,
      render: CurrentStage,
    },
    {
      title: "Product Plan",
      dataIndex: [lead.activeKey === "PRE_LENDER"?"lenderProposalDTO":"caseDetails", "allInsuranceProductPlan"],
      key: "allInsuranceProductPlan",
      ellipsis: true,
    },
    {
      title: "Version",
      width: 50,
      dataIndex: "productVersion",
      key: "version",
      align: "center",
    },
    {
      title: "Case Stage",
      dataIndex: lead.activeKey === "PRE_LENDER" ? "caseStatus": ["caseDetails", "caseStatus"],
      key: "stage",
    },
    {
      title: "Journey Stage",
      dataIndex: "currDropOffStage",
      key: "currDropOffStage",
      width: 50,
      ellipsis: true,
      render: colDropOffStage,
    },
    {
      title: "Frequency of Payment",
      dataIndex: [lead.activeKey === "PRE_LENDER"?"lenderProposalDTO":"caseDetails", "allInsuranceFrequencyOfPayment"],
      key: "allInsuranceFrequencyOfPayment",
    },
    {
      title: "Premium (INR)",
      dataIndex: [lead.activeKey === "PRE_LENDER"?"lenderProposalDTO":"caseDetails", "allInsurancePremium"],
      key: "allInsurancePremium",
    },
    {
      title: "Lead Source",
      dataIndex: lead.activeKey === "PRE_LENDER" ?["leadOriginatorDetails", "companyName"] : ["caseDetails", "connectorDetails", "companyName"],
      key: "sourceOfCase",
    },
    {
      title: "Mobile Number",
      dataIndex: ["contactDetails", "mobileNumber"],
      key: "mobileNumber",
      render: colMobileNumber,
    },
    {
      title: "Case Created Date",
      dataIndex: "caseCreatedDate",
      key: "caseCreatedDate",
      width: 180,
      render: colCaseCreatedDate,
    },
    {
      title: "Days Open",
      dataIndex: "daysOpen",
      key: "daysOpen",
      width: 30,
    },
    {
      title: "Assign to Sales User",
      dataIndex: lead.activeKey === "PRE_LENDER" ? "assignedToSalesUserName" : ["caseDetails", "assignedToUserDetails", "firstName"],
      key: "assignedSalesUserName",
      width: 30,
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      align: "center",
      width: 60,
      render: colAction,
    },
  ];

  /* other functions */
  const refreshLead = () => {
    //dispatch(setFilterData({}));
    dispatch(setRestFilterData());
    dispatch(setActiveKey("PRE_LENDER"));
    dispatch(setPreLenderCase("ALL"));
    if (tenantInfo?.businessProductType === "INSURANCE") {
      dispatch(setPostLenderCase("LOGGED"));
    } else {
      dispatch(setPostLenderCase("ASSIGNED"));
    }
    dispatch(setDisbursementCase("ALL"))
    //setSelectedFilterData({});
    dispatch(setIsShowFilter(false));
    form.setFieldsValue({ searchBox: "" });
    dispatch(setLeadSearchParam(""));
    dispatch(setLeadPageNo(1));
    // getAllLeadsData(1, lead.pageSize, "", {});
  };

  const goToLeadEdit = (item: any) => {
    let caseId = lead?.activeKey == "PRE_LENDER" ? item?.caseId : item?.caseDetails?.caseId;
    if (
      (item?.loanProductId?.length ?? 0) == 0 ||
      item?.productVersion != "V2"
    ) {
      history.push(`/lead/edit/${caseId}`);
    } else {
      goToLeadDetails(item);
    }
  };

  const goToLeadDetails = (item: any) => {
    let caseId = lead?.activeKey == "PRE_LENDER" ? item?.caseId : item?.caseDetails?.caseId;
    history.push(`/lead/details/${caseId}`);
  };

  const goToOneView =(item:any) =>{
    if(isCustomer360Enabled){
      setCustomerCaseId(lead?.activeKey == "PRE_LENDER" ? item?.caseId : item?.caseDetails?.caseId)
      setIsOneView(true)       
    }
    else{
      notification.error({message:"The Customer 360 feature is currently disabled. Contact the administration team to enable it"})
    }       
  }

  const handleClick = (caseId) => {
    API_SERVICE.getWhatsAppDocumentValidate(caseId)
      .then(({ data }) => {
        if (data.payload.validToSend) {
          setIsModalWhatsappVisible(true);
        } else {
          setIsModalWhatsappVisible(false);
          setSuccessMessage(data.payload.message);
          setIsSuccessModalVisible(true);
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  };

  const getShareLinkId = (item: any) => {
    let caseId = lead.activeKey === "PRE_LENDER" ? item?.caseId : item?.caseDetails?.caseId
    API_SERVICE.getShareLinkId(caseId)
      .then(({ data }) => {
        navigator.clipboard.writeText(data?.payload);
      })
      .catch((error) => {
        notification.error({ message: API_SERVICE.handleErrors(error) });
      });
  };

  const resetCounts = () => {
    setCounts((counts) => ({
      ...counts,
      totalCases: 0,
      totalCasesInLeadState: 0,
      totalCasesInProspectState: 0,
      totalCasesInVisitState: 0,
      totalCasesInDocumentState: 0,
      totalLenderAssignedCases: 0,
      totalLenderLoggedInCases: 0,
      totalLenderSanctionedCases: 0,
      totalLenderRejectedCases: 0,
      totalLenderWithdrawnCases: 0,
      totalLenderPendencyCases: 0,
      totalLenderDisbursedCases: 0,
      totalInsurerPolicyIssued: 0,
      totalInsurerPolicyCounterOffer:0,
      totalInsurerPolicyUnderwritingReject:0,
    }));
  };

  const getAllLeadsData = (
    pageNo: number = 1,
    pageSize: number = 10,
    searchValue: any = null,
    //caseStatus: string = lead.preLenderCase,
    filter: any = lead.filterData
  ) => {
    let params = {};
    if (
      lead.activeKey === "PRE_LENDER" &&
      (lead.preLenderCase === "VISIT" ||
        lead.preLenderCase === "LEAD" ||
        lead.preLenderCase === "DOCUMENTATION" ||
        lead.preLenderCase === "PROSPECT")
    ) {
      params = {
        ...filter,
        searchParam: searchValue,
        status: lead.preLenderCase,
      };
    }
    else if (
      lead.activeKey === "DISBURSEMENTS" &&
      (lead.disbursementCase === "ALL" ||
        lead.disbursementCase === "COMPLETE" ||
        lead.disbursementCase === "INCOMPLETE"
      )
    ) {
      params = {
        ...filter,
        searchParam: searchValue,
        disbursalStatus: lead.disbursementCase,
      };
    } 
    else {
      params = {
        ...filter,
        searchParam: searchValue,
      };
    }

    if (lead.activeKey === "PRE_LENDER")
      getPreLenderData(pageNo, pageSize, params);
    else if (lead.activeKey === "POST_LENDER")
      getPostLenderData(lead.postLenderCase, pageNo, pageSize, params);
    else if (lead.activeKey === "DISBURSEMENTS")
      getDisbLenderData(pageNo, pageSize, params);
  };

  const getPreLenderData = (pageNo, pageSize, params) => {
    setLoading(true);
    setAllLeadsData([]);
    API_SERVICE.getLeadsByFilter(pageNo, pageSize,"LIST_LEADS", params)
      .then(({ data }) => {
        const hasData = data?.payload?.content?.length > 0;
        if (!hasData) {
          notification.error({ message: "No data found." });
        }
        mapLeadsData(data);
        fetchCampaignOptions();
      })
      .catch((error) => {
        mapLeadsData([]);
        notification.error({ message: API_SERVICE.handleErrors(error) });
      })
      .finally(() => setLoading(false));
      
  };

  const getPostLenderData = (caseStatus, pageNo, pageSize, params) => {
    setLoading(true);
    setAllLeadsData([]);
    API_SERVICE.getLeadsByFilterPostCase(caseStatus, pageNo, pageSize,"LIST_LEADS", params)
      .then(({ data }) => {
        if (data?.payload?.content) {
          mapLeadsData(data);
        }
      })
      .catch((error) => {
        mapLeadsData([]);
        notification.error({ message: API_SERVICE.handleErrors(error) });
      })
      .finally(() => setLoading(false));
  };
  
  const getDisbLenderData=(pageNo, pageSize, params) =>{
    setLoading(true);
    setAllLeadsData([]);
    API_SERVICE.getLeadsByFilterDisbCase(pageNo, pageSize, "LIST_LEADS" , params)
      .then(({ data }) => {
        if (data?.payload?.content) {
          mapLeadsData(data);
        }
      })
      .catch((error) => {
        mapLeadsData([]);
         notification.error({ message: API_SERVICE.handleErrors(error) });
      })
      .finally(() => {
        setLoading(false)
       
    });
      
  }

  const mapLeadsData = (data: any) => {
    //setCheckedListFilter(data?.payload);
    resetCounts();
    setCounts((counts) => ({
      ...counts,
      totalCases: data?.payload?.totalCases ?? 0,
      totalCasesInLeadState: data?.payload?.totalCasesInLeadState ?? 0,
      totalCasesInProspectState: data?.payload?.totalCasesInProspectState ?? 0,
      totalCasesInVisitState: data?.payload?.totalCasesInVisitState ?? 0,
      totalCasesInDocumentState: data?.payload?.totalCasesInDocumentState ?? 0,
      totalLenderAssignedCases: data?.payload?.totalLenderAssignedCases ?? 0,
      totalLenderLoggedInCases: data?.payload?.totalLenderLoggedInCases ?? 0,
      totalLenderSanctionedCases:
        data?.payload?.totalLenderSanctionedCases ?? 0,
      totalLenderRejectedCases: data?.payload?.totalLenderRejectedCases ?? 0,
      totalLenderWithdrawnCases: data?.payload?.totalLenderWithdrawnCases ?? 0,
      totalLenderPendencyCases: data?.payload?.totalLenderPendencyCases ?? 0,
      totalLenderDisbursedCases: data?.payload?.totalLenderDisbursedCases ?? 0,
      totalInsurerPolicyIssued: data?.payload?.totalInsurerPolicyIssued ?? 0,
      totalInsurerPolicyCounterOffer:data?.payload?.totalInsurerPolicyCounterOffer ?? 0,
      totalInsurerPolicyUnderwritingReject:data?.payload?.totalInsurerPolicyUnderwritingReject ?? 0,
    }));
    setTotalRecords(data?.payload?.totalElements);
    setAllLeadsData(data?.payload?.content);
    setIsWhatsappEnable(data?.payload?.whatsappEnabled);
  };

  const handlePaginationChange = (pagination) => {
    let page = pagination.pageSize !== lead.pageSize ? 1 : pagination.current;
    dispatch(setLeadPageNo(page));
    dispatch(setLeadPageSize(pagination.pageSize));
    getAllLeadsData(page, pagination.pageSize, lead.searchParam);
    window.scrollTo(0, 0);
  };

  const handleMobilePaginationChange = (current: any, pageSize: any) => {
    dispatch(setLeadPageNo(current));
    dispatch(setLeadPageSize(pageSize));
    getAllLeadsData(current, pageSize, lead.searchParam);
    window.scrollTo(0, 0);
  };

  const handlePreLenderTagChange = (i: number, value: string) => {
    dispatch(setLeadPageNo(1));
    dispatch(setPreLenderCase(value));
  };
  
  const handleDisbursementTagChange = (i: number, value: string) => {
    dispatch(setLeadPageNo(1));
    dispatch(setDisbursementCase(value));
  };

  const handlePostLenderTagChange = (i: number, value: string) => {
    dispatch(setLeadPageNo(1));
    dispatch(setPostLenderCase(value));
  };

  const activeTabChange = (key) => {
    setAllLeadsData([]);
    dispatch(setLeadPageNo(1));
    dispatch(setActiveKey(key));
  };

  const getColumns = () => {
    const tmpCol = tenantInfo?.businessProductType === "INSURANCE"
        ? columnsInsurence
        : lead.activeKey === "PRE_LENDER" ? preLenderColumns : columns;;

    const co = tmpCol.filter(
      (col) =>
        col.key !==
        ("VISIT" !== lead.preLenderCase && lead.activeKey === "PRE_LENDER"
          ? ""
          : "currDropOffStage")
    );
    const co1 = co?.filter(
      (col) =>
        col.key !==
        (lead.preLenderCase == "ALL" && lead.activeKey === "PRE_LENDER"
          ? ""
          : "allLenderStages")
    );
    return co1;
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record: any) => ({}),
    preserveSelectedRowKeys:true
  };

  const fetchCampaignOptions = async () => {
    API_SERVICE.getCampaignDetailName()
      .then(({ data }: any) => {
        setOptions(data.payload);
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  };

  const onChangeDiallerCampaignType = (item, opt) => {
    setSelectedValue(opt);
  };

  const searchAssignTo = (ev: any) => {
    if (ev.length != 0) {
      const params = {
        name: ev,
      };
      API_SERVICE.getUsersWithRole(params).then(({ data }) => {
        if (data) {
          setAssignToData(data.payload);
        }
      });
    }
  };

  const searchAssignToDialler = (ev: any) => {
    if (ev.length !== 0) {
      const params = {
        filterNameParam: ev,
        status:"ACTIVE"
      };
      API_SERVICE.getDialler(params).then(({ data }) => {
        if (data) {
          setOptions(data.content);
        }
      });
    } else {
      API_SERVICE.getCampaignDetailName().then(({ data }) => {
        if (data) {
          setSelectedValue("");
          setOptions(data.payload);
        }
      });
    }
  };

  const selectAssignTo = (item, opt) => {
    setSelectedAssignTo(opt);
  };

  const assignSalesUserToLead = () => {
    if (undefined === selectedRowKeys || selectedRowKeys?.length === 0) {
      notification.error({ message: "Please select a lead to approve." });
      return;
    }
    if (
      undefined === selectedAssignTo ||
      null === selectedAssignTo ||
      undefined === selectedAssignTo?.userId ||
      null === selectedAssignTo.userId
    ) {
      notification.error({ message: "Please assignee to assign a lead." });
      return;
    }
    if (
      selectedRowKeys &&
      selectedRowKeys?.length > 0 &&
      selectedAssignTo &&
      selectedAssignTo?.userId
    ) {
      //const tempRowKey = selectedRowKeys.map(id=>{return `${id}1`})
      const params = {
        dsaCaseIds: selectedRowKeys,
        salesUserId: selectedAssignTo?.userId,
      };
      setSelectedCaseIds(selectedRowKeys);
      API_SERVICE.assignSalesUserToLead(params)
        .then(({ data }) => {
          if (data) {
            let tmp = [""];
            tmp.push("salesUserId");
            setSelectedRowKeys([]);
            //findErrorCaseIds(params)
            if (data.payload.errorCases) {
              notification.error({ message: data.payload.message });
            } else {
              notification.success({ message: data.payload.message });
            }
            form.resetFields(tmp);
            console.log(errorCaseIds, selectedCaseIds);
            getAllLeadsData(lead.pageNo, lead.pageSize, lead.searchParam);
          }
          if (data.payload.errorCases) {
            setErrorDisplay(true);
            const tmpErrorCaseId = data.payload.errorCases;
            const errorCaseId = data.payload.errorCases; //tmpErrorCaseId.map(caseId=>{return caseId.substr(0,(caseId.length)-1)})
            setErrorCaseIds(errorCaseId);
            console.log(errorCaseIds, selectedCaseIds);
          }
        })
        .catch((e: any) => {
          notification.error({ message: API_SERVICE.handleErrors(e) });
        });
    }
  };

  const assignDiallerToLead = () => {
    if (
      undefined === selectedValue ||
      null === selectedValue ||
      undefined === selectedValue?.campaignId ||
      null === selectedValue?.campaignId
    ) {
      notification.error({ message: "Please submit to lead." });
      return;
    }
    if (
      selectedRowKeys &&
      selectedRowKeys?.length > 0 &&
      selectedValue?.campaignId
    ) {
      const params = {
        campaignId: selectedValue?.campaignId,
        caseIds: selectedRowKeys,
      };
      setSelectedCaseIds(selectedRowKeys);
      API_SERVICE.assignDiallerToLead(params)
        .then(({ data }) => {
          if (data) {
            let tmp = [""];
            tmp.push("diallerId");
            setSelectedRowKeys([]);
            setSelectedValue("");
            fetchCampaignOptions();
            if (data.statusCode===200) {
              notification.success({ message: data.payload });
              
            } else {
              notification.error({ message: data.payload });
            }
            form.resetFields(tmp);
            getAllLeadsData(lead.pageNo, lead.pageSize, lead.searchParam);
            searchAssignToDialler(0);
          }
        })
        .catch((e: any) => {
          notification.error({ message: API_SERVICE.handleErrors(e) });
        });
    }
  };

  const handleModalOk = () => {
    const caseId = lead?.activeKey == "PRE_LENDER" ? selectedLead?.caseId : selectedLead.caseDetails.caseId;
    API_SERVICE.sendWhatsAppMessage(caseId)
      .then(({ data }) => {
        setIsModalWhatsappVisible(false);
        if (data.payload) {
          notification.success({ message: data.payload });
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  };

  const handleModalCancel = () => {
    setIsModalWhatsappVisible(false);
  };
  const handleModalmessage = () => {
    setIsSuccessModalVisible(false);
  };

  const customStyles: any = { "--bgColor": appColors?.appPrimaryColor ?? "" };
  const btnPrimaryStyles: any = {
    "--btnColor": appColors?.appPrimaryColor ?? "",
  };
  const btnStylePrimary: any = {"--custColor": appColors?.appPrimaryColor}

  const whatsapp = () => {
    return (
      <Modal
        centered
        width={450}
        visible={isModalWhatsappVisible}
        footer={null}
        closable={false}
      >
        <div
          style={{
            paddingBottom: "40px",
            paddingTop: "40px",
            paddingLeft: "15px",
            paddingRight: "15px",
          }}
        >
          <p
            style={{
              textAlign: "center",
              marginTop: "10px",
              marginBottom: "35px",
              marginLeft: "5px",
              fontSize: "medium",
            }}
          >
            Is {selectedLead?.contactDetails?.mobileNumber} the valid contact
            number? <br />
            If not, please update lead details.
          </p>
          <div
            style={{ display: "flex", gap: "10px", justifyContent: "center" }}
          >
            <Button
              className="dynamic-btn-primary"
              style={
                {
                  "--btnColor": appColors?.appPrimaryColor ?? "",
                  width: "155px",
                  height: "40px",
                  borderRadius: "8px",
                } as any
              }
              type="primary"
              onClick={handleModalOk}
            >
              Confirm
            </Button>
            <Button
              className="dynamic-btn-default"
              type="default"
              style={
                {
                  "--borderColor": appColors?.appSecondaryColor ?? "",
                  width: "155px",
                  height: "40px",
                  borderRadius: "8px",
                } as any
              }
              onClick={handleModalCancel}
            >
              Back
            </Button>
          </div>
        </div>
      </Modal>
    );
  };

  const renderOneView = () => {
    return (
      <Modal
        title = {<div style={{ textAlign: 'center' }}>Customer 360</div>}
        width={1000}
        visible={isOneView}
        footer={null}
        closable
        onCancel={()=>setIsOneView(false)}
        >
        <Customer360 
          caseId={customerCaseId}
          customer360Data={null}
          isPAPQ={false}
        />
      </Modal>
    );
  };

  const message = () => {
    return (
      <Modal
        centered
        width={450}
        visible={isSuccessModalVisible}
        footer={null}
        closable={false}
      >
        {" "}
        <p
          style={{
            textAlign: "center",
            marginTop: "30px",
            marginBottom: "15px",
            marginLeft: "5px",
            fontSize: "medium",
          }}
        >
          {successMessage}
        </p>
        <Button
          className="dynamic-btn-default"
          style={
            {
              "--borderColor": appColors?.appSecondaryColor ?? "",
              width: "155px",
              height: "40px",
              borderRadius: "8px",
              margin: "20px",
              marginLeft: "110px",
            } as any
          }
          type="default"
          onClick={handleModalmessage}
        >
          OK
        </Button>
      </Modal>
    );
  };

  const bulkAssignError = () => {
    return (
      <Modal
        centered
        //style={{top:20}}
        width={350}
        footer={null}
        closable={false}
        visible={errorDisplay}
      >
        <div
          style={{ display: "grid", alignItems: "center", marginTop: "5px" }}
        >
          {/**/}
          <p>
            There was an error in assigning some cases. Please retry assignment
            for the cases highlighted on screen
          </p>
          <Button
            style={{
              bottom: "15px",
              justifyContent: "center",
              left: "70px",
            }}
            size="large"
            className="button-submit"
            htmlType="submit"
            onClick={() => setErrorDisplay(false)}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    );
  };

  const menuList = (
    <Menu
      selectable
      className="menu-list"
      style={
        {
          "--bgColor": appColors?.appPrimaryLightColor ?? "",
          "--color": appColors?.appPrimaryColor ?? "",
        } as any
      }
      onClick={(item: any) => {
        if (item?.key == "BulkUpload") {
          history.push("/lead/bulkUpload");
        } else if(item?.key == "BatchCampaign"){
          history.push("/lead/batchCampaign");
        } else if(item?.key == "BulkLogin"){
          dispatch(setBulkLoginStartPageNo(1))
          dispatch(setBulkLoginStartPageSize(10))
          history.push("/lead/bulkLogin");
        } else {
          history.push("/lead/bulkUpdate");
        }
      }}
      items={[
        {
          key: "BulkUpload",
          label: "Bulk Upload",
        },
        {
          key: "BulkUpdate",
          label: "Status Update",
          style: {
            display:
              tenantInfo?.businessProductType === "INSURANCE" 
              ? "none" 
              : userRolePermission["ApprovePayout"] ||
                userRolePermission["Admin"] ||
                getUser()?.userDetails?.department?.toLowerCase() == "back office"
                ? ""
                : "none",
          },
        },
        {
          key: "BatchCampaign",
          label: "Batch Campaign",
          style: {
            display: 
              tenantInfo?.businessProductType === "INSURANCE" 
              ? "none" 
              : dialerCampaignEnabled ? "" : "none",
          },
        },
        {
          key: "BulkLogin",
          label: "Bulk Login",
          style: {
            display:
              tenantInfo?.businessProductType === "INSURANCE" 
              ? "none" 
              : userRolePermission["Admin"] ||
                getUser()?.userDetails?.department?.toLowerCase() == "back office"
                ? ""
                : "none",
          },
        },
      ]}
    />
  );

  const renderTabs = () => {
    return (
      <Tabs
        activeKey={lead.activeKey}
        onChange={(key) => activeTabChange(key)}
        style={{ marginBottom: "20px" }}
      >
        <TabPane
          tab={
            tenantInfo?.businessProductType === "INSURANCE"
              ? "Pre Insurer"
              : "Pre Lender"
          }
          key="PRE_LENDER"
        >
          {preLenderCases.map((item: any, i: number) => (
            <CheckableTag
              className="custom-checkable"
              style={customStyles}
              key={item.key}
              checked={item.key === lead.preLenderCase}
              // onChange={() => dispatch(setPreLenderCase(item.key))}
              onChange={(checked) => handlePreLenderTagChange(i, item.key)}
            >
              {item.value}
            </CheckableTag>
          ))}
        </TabPane>
        <TabPane
          tab={
            tenantInfo?.businessProductType === "INSURANCE"
              ? "Post Insurer"
              : "Post Lender"
          }
          key="POST_LENDER"
        >
          {postLenderCases.map((item: any, i: number) => (
            <CheckableTag
              className="custom-checkable"
              style={customStyles}
              key={item.key}
              checked={item.key === lead.postLenderCase}
              // onChange={() => dispatch(setPostLenderCase(item.key))}
              onChange={(checked) => handlePostLenderTagChange(i, item.key)}
            >
              {item.value}
            </CheckableTag>
          ))}
        </TabPane>
        {isTenantWorkingCapitalEnabled &&
          <TabPane tab="Disbursements" key="DISBURSEMENTS">
          {disbursementCases.map((item: any, i: number) => (
              <CheckableTag
                className="custom-checkable"
                style={customStyles}
                key={item.key}
                checked={item.key === lead.disbursementCase}
                onChange={(checked) =>
                  handleDisbursementTagChange(i, item.key)
                }
              >
                {item.value}
              </CheckableTag>
            ))}
          </TabPane>
        }
      </Tabs>
    );
  };

  const renderLeadListItem = (item: any) => {
    let value = {} as any;
    value = prospectOnboardingStatus?.find((i: any) => {
      return i?.key === item?.currDropOffStage;
    });
    const dropOffStageValue = value?.value;
    const isAction =
  ("LEAD" === lead?.preLenderCase && "PRE_LENDER" === lead?.activeKey) ||
  ("PRE_LENDER" === lead?.activeKey &&
    "ALL" === lead?.preLenderCase &&
    item?.caseStatus === "Lead");
    let isLoanProduct = (item?.loanProductId?.length ?? 0) == 0;
    let caseId = lead?.activeKey == "PRE_LENDER" ? item?.caseId : item?.caseDetails?.caseId;
    return (
      <>
        <List.Item style={{ padding: "0px 0px" }}>
          <Card>
            <div >
              <Checkbox 
                checked={selectedRowKeys?.includes(caseId)}
                style={{position:'absolute', top:6, left:8}} 
                onChange={(value) => {
                  if(selectedRowKeys?.includes(caseId)) {
                    const fil = selectedRowKeys?.filter((id) => id != caseId);
                    setSelectedRowKeys(fil);
                  } else {
                    setSelectedRowKeys([...selectedRowKeys, caseId])
                  }
                }} 
              />
              <Row gutter={24} onClick={() => goToLeadDetails(item)}>
                <Col span={12}>
                  <label className="leadlist-title" style={{marginLeft:"20px"}}>
                    <Tooltip color={"#1A3175"} title="Indicates whether case has been sent to dialler campaign">
                      <img
                        src={bullHorn}
                        alt=""
                        height={24}
                      />
                    </Tooltip>
                    Lead
                  </label>
                  <br />
                  {item.contactDetails.firstName}
                </Col>
                <Col span={12} className="text-right">
                  {item.loanType}
                </Col>
              </Row>
              <Row gutter={24} className="title-space">
                <Col span={12} onClick={() => goToLeadDetails(item)}>
                  <label className="leadlist-title"> Drop Off Stage</label>
                  <br />
                  <p>{dropOffStageValue} </p>
                </Col>
                <Col span={12}>
                  <label className="leadlist-title" onClick={() => goToLeadDetails(item)}> Mobile Number</label>
                  <br />
                  <div>
                    <span onClick={() => goToLeadDetails(item)}> {getMaskedMobile(userRolePermission["MaskMobileNumber"], item?.contactDetails?.mobileNumber)}</span>
                    <Button
                      size="small"
                      icon={<IconCall  style={{
                        marginBottom: "10px", // Adjust the margin value as needed
                      }}/>}
                      style={{marginLeft:"10px",border:"none"}}
                      onClick={() => {
                        if (item?.contactDetails?.mobileNumber) {
                          window.location.href = `tel:${item.contactDetails.mobileNumber}`;
                        } else {
                          alert("Mobile number not available!");
                        }
                      }}
                    />
                  </div>
                </Col>
                {/* <Col span={6} style={{ paddingLeft: "38px" }}>
                  <label className="leadlist-title">Version</label>
                  <br />
                  {item?.productVersion}
                </Col> */}
              </Row>

              <Row gutter={24} className="title-space" onClick={() => goToLeadDetails(item)}>
                <Col span={12}>
                  <label className="leadlist-title"> Pre-Qualified offer</label>
                  <br />
                  <p><span>{item?.allPreQualifiedLenderNames}</span> &nbsp;&nbsp; <span> {item?.allPreQualifiedLenderAmounts}</span> </p>
                </Col>

                <Col span={12}>
                  <label className="leadlist-title"> Pre-Qualified Expiry Date</label>
                  <br />
                  <p> {item?.allPreQualifiedExpiryDates}
                  </p>
                </Col>
              </Row>

            </div>
            <Row gutter={14} className="title-space">
              <Col span={8} onClick={() => goToLeadDetails(item)}>
                <label className="leadlist-title">Created</label>
                <br />
                {moment(item?.caseCreatedDate)
                  .locale("en")
                  .format("MMM, DD, YYYY HH:mm")}
              </Col>
              <Col span={6} className="text-right" onClick={() => goToLeadDetails(item)}>
                <label className="leadlist-title">Days Open</label>
                <br />
                {item.daysOpen}
              </Col>
              <Col
                span={8}
                className="text-right"
                style={{ paddingLeft: "40px" }}
              >
                <label className="leadlist-title">Share</label>
                <br />
                <Space
                  className="action-button"
                  size="small"
                  style={{ gap: "0px" }}
                >

                  <Button
                    className="custome-btn-icon-secondary"
                    style={
                      { "--bgColor": appColors?.appSecondaryColor ?? "" } as any
                    }
                    size="small"
                    hidden={
                      "LEAD" === lead.preLenderCase &&
                      "PRE_LENDER" === lead.activeKey
                    }
                    onClick={() => getShareLinkId(item)}
                    icon={<IconShare />}
                  />
                  {isWhatsappEnable && (
                    <Button
                      size="small"
                      hidden={!item?.isWhatsAppEnabled}
                      onClick={() => {
                        setSelectedLead(item);
                        handleClick(item?.caseId);
                      }}
                      icon={
                        <img
                          src={whatsappIcon}
                          alt=""
                          height={24}
                          style={{ marginTop: "-4px" }}
                        />
                      }
                    />
                  )}
                  <Button
                    className="custome-btn-icon-play"
                    style={{ "--bgColor": appColors?.appPrimaryColor ?? "" } as any}
                    size="small"
                    type="text"
                    onClick={() => goToOneView(item)}
                    icon={<IconCustomer360 />}
                  />
                </Space>
              </Col>
            </Row>
          </Card>
        </List.Item>
      </>
    );
  };

  return (
    <>
      {bulkAssignError()}
      {whatsapp()}
      {message()}
      {renderOneView()}
      <div className="content-box">
        <Form form={form} className="app-filter-bar">
          <div className="app-filter-bar-left">
            <Form.Item
              name="searchBox"
              style={{ flex: 1, marginBottom: "0px" }}
            >
              <Input
                size="large"
                className="search-box"
                placeholder="Search"
                onChange={debounce((event) => {
                  if (event?.target?.value?.length > 2) {
                    dispatch(setLeadSearchParam(event.target.value));
                    dispatch(setLeadPageNo(1));
                  } else if (event?.target?.value?.length == 0) {
                    dispatch(setLeadSearchParam(""));
                    dispatch(setLeadPageNo(1));
                  }
                }, 600)}
                allowClear
                prefix={<FaSearch />}
              />
            </Form.Item>
            <Button
              type="primary"
              className="filter-btn"
              onClick={() => dispatch(setIsShowFilter(!lead.isShowFilter))}
            >
              <img src={blackFilterIcon} alt="" />
              <div
                className="badge-green"
                hidden={
                  !(
                    lead.filterData?.connectorId ||
                    lead.filterData?.connectorIds?.length ||
                    lead.filterData?.employeeId ||
                    lead.filterData?.employeeIds?.length ||
                    lead.filterData?.loanProductIds?.length ||
                    lead.filterData?.location ||
                    lead.filterData?.managerHierarchy ||
                    lead.filterData?.caseIdentifier
                  )
                }
              />
            </Button>

            <Tooltip title="Refresh">
              <Button
                type="primary"
                className="filter-btn"
                onClick={() => refreshLead()}
              >
                <img src={blackRefereshIcon} alt="" />
              </Button>
            </Tooltip>
          </div>
          <div className="app-filter-bar-right">
            <OIButton 
              type="primary" 
              label="Add Lead" 
              className="w-170 h-center"
              style={{"--custColor": appColors?.appPrimaryColor} as any}
              hidden={
                !(
                  userRolePermission["CreateLead"] ||
                  userRolePermission["Admin"]
                )
              }
              onClick={() => history.push("/lead/add-lead")}
            />
            <Dropdown
              overlay={menuList}
              placement="bottomRight"
              arrow={{ pointAtCenter: false }}
            >
              <Button
                type="primary"
                className="dynamic-btn-primary w-170"
                style={btnPrimaryStyles}
                hidden={
                  !(
                    userRolePermission["CreateLead"] ||
                    userRolePermission["Admin"]
                  )
                }
              >
                Bulk Operations
                <DownOutlined />
              </Button>
            </Dropdown>
          </div>
        </Form>

        {lead.isShowFilter && (
          <LeadFilterConnector key="NEW_LEAD_FILTER" />
        )}

        {renderTabs()}

        {isMobile ? (
          <List
            style={{ width: "100%" }}
            grid={{ gutter: 24, column: 1, xs: 1, sm: 1, md: 1, lg: 1 }}
            pagination={{
              onChange: (page, pageSize) => {
                handleMobilePaginationChange(page, pageSize);
              },
              current: lead.pageNo,
              pageSize: lead.pageSize,
              total: totalRecords,
            }}
            itemLayout="horizontal"
            dataSource={allLeadsData}
            loading={loading}
            renderItem={renderLeadListItem}
          />
        ) : (
          <Table
            className="dynamic-pagination-checkbox"
            style={customStyles}
            size="small"
            loading={loading}
            scroll={{ x: "max-content" }}
            dataSource={allLeadsData}
            rowKey={(record) => "PRE_LENDER" === lead.activeKey ? record?.caseId : record?.caseDetails?.caseId}
            rowClassName={(record: any) =>
              errorCaseIds.includes(record?.caseDetails?.caseId)
                ? "selected-row"
                : ""
            }
            rowSelection={rowSelection}
            columns={getColumns()}
            pagination={{
              current: lead.pageNo,
              pageSize: lead.pageSize,
              total: totalRecords,
            }}
            onChange={handlePaginationChange}
          />
        )}

        <div className="assign-to-view">
          <div className="assign-to-view1">
            <Form form={form}>
              <Form.Item label="Assign To:" name="salesUserId">
                <AutoComplete
                  className="custom-auto-compleat"
                  onSearch={debounce(searchAssignTo, 1000)}
                  placeholder="Search Mobile Number or Name"
                  dropdownClassName="custom-option-list"
                  onSelect={selectAssignTo}
                >
                  {assignToData.map((item: any, i: any) => (
                    <Select.Option
                      key={item.userId}
                      {...item}
                      value={item.fullName}
                    >
                      <Row gutter={[16, 16]} className="assign-list">
                        <Col
                          className="left"
                          span={16}
                          style={{ marginTop: isMobile ? "35px" : "" }}
                        >
                          <span className="name">{item.fullName}</span>
                          <br />
                          <span className="city">
                            {item?.address?.city && item?.address?.city}
                          </span>
                        </Col>
                        <Col className="right" span={8}>
                          <span className="mob">
                            {item?.phoneNumber && item?.phoneNumber}
                          </span>
                        </Col>
                      </Row>
                    </Select.Option>
                  ))}
                </AutoComplete>
                &nbsp;&nbsp;&nbsp;
              </Form.Item>
            </Form>
            <OIButton 
              type="primary"
              label="Assign"
              size="small"
              style={btnStylePrimary}
              onClick={assignSalesUserToLead}
            />
          </div>
          {dialerCampaignEnabled &&
            <div className="assign-to-view1">
              <Form form={form}>
                <Form.Item label="Submit To:" name="diallerId">
                
                <AutoComplete
                    className="custom-auto-compleat"
                    onSearch={debounce(searchAssignToDialler, 1000)}
                    placeholder="Search Dialler Campaign Name"
                    dropdownClassName="custom-option-list"
                    onSelect={onChangeDiallerCampaignType}
                  >
                    {options.map((item: any, i: any) => (
                      <Select.Option
                        key={item.campaignId}
                        {...item}
                        value={item.campaignName}
                      >
                        <Row gutter={[16, 16]} className="assign-list">
                          <Col
                            className="left"
                            span={16}
                          >
                            <span className="name">{item.campaignName}</span>
                          </Col>
                        </Row>
                      </Select.Option>
                    ))}
                  </AutoComplete>
                  &nbsp;&nbsp;&nbsp;
                </Form.Item>
              </Form>
              <OIButton 
                type="primary"
                label="Submit"
                size="small"
                style={btnStylePrimary}
                onClick={assignDiallerToLead}
                disabled={!(selectedRowKeys?.length && selectedValue?.campaignId)}
              />
            </div>
          }
        </div>

      </div>
      {loading && <AppLoading />}
    </>
  );
};

export default LeadPage;
